import AbstractApiRepository from '~base/api/AbstractApiRepository';
import { IAxiosResponse } from '~base/api/axios/IAxiosInterfaces';

export default class AttachedFilesApiRepository extends AbstractApiRepository {
  getAttachedDocuments = (params: URLSearchParams) => {
    return this.apiClient.get<IAxiosResponse<[]>>({
      url: '/AttachedDocuments/GetAttachedDocuments',
      config: { params },
    });
  };

  addAttachedDocument = (formData: FormData) => {
    return this.apiClient.post({
      url: '/AttachedDocuments/AddAttachedDocument',
      data: formData,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    });
  };

  deleteAttachedDocument = (params: URLSearchParams) => {
    return this.apiClient.delete<IAxiosResponse<[]>>({
      url: '/AttachedDocuments/DeleteAttachedDocument',
      config: { params },
    });
  };

  deleteAttachedDocuments = (params: URLSearchParams) => {
    return this.apiClient.delete({
      url: '/AttachedDocuments/DeleteAttachedDocuments',
      config: { params },
    });
  };
}
